module.exports = __webpack_public_path__ + "static/img/icon_sf.fc57d05a.png";